import React from "react";
import "./LoadingSpinner.css";

export default function LoadingSpinner() {
  return (
    <div class="cssload-loader">
      <div class="cssload-inner cssload-one"></div>
      <div class="cssload-inner cssload-two"></div>
      <div class="cssload-inner cssload-three"></div>
    </div>
  );
}
